export default class ResponseEntity {
  constructor(public readonly id: any = undefined) {}
  static convert(input: any): ResponseEntity {
    if (input instanceof ResponseEntity) return input;

    if (input.id === undefined || input.id === null)
      throw new ResponseEntityConversionError("id", input);
    return new ResponseEntity(input.id);
  }
}

export class InputEntity {}

export class RequestEntity extends InputEntity {}

export class DtoConversionError extends Error {
  constructor(
    public dtoName: string,
    public propertyName: string,
    public rawData: any,
    public hint?: string
  ) {
    super(
      `DtoConversionError (${dtoName}): Invalid ${propertyName} \`${rawData[propertyName]}\`` +
        (hint !== undefined && hint !== null ? `: ${hint}` : "")
    );
  }

  static stack(
    dtoName: string,
    previous: DtoConversionError
  ): DtoConversionError {
    return new DtoConversionError(
      dtoName + previous.dtoName,
      previous.propertyName,
      previous.rawData,
      previous.hint
    );
  }

  static propagate<T>(dtoName: string, callback: () => T): T {
    try {
      return callback();
    } catch (error) {
      if (error instanceof DtoConversionError)
        throw DtoConversionError.stack(dtoName, error);
      else throw error;
    }
  }
}

class ResponseEntityConversionError extends DtoConversionError {
  public static dtoName: string = "OutputEntity";
  constructor(propertyName: string, rawData: any, hint?: string) {
    super(ResponseEntityConversionError.dtoName, propertyName, rawData, hint);
  }
}

export function enumConvert<T extends object>(
  enummeration: T,
  key: any
): T[keyof T] {
  if (key in enummeration) {
    return enummeration[key as keyof T];
  } else {
    throw new DtoConversionError(enummeration.toString(), "key", {
      key: key,
    });
  }
}

/**
 * Generic function for transforming string values into an Enum.
 * @param enumType The enum to validate against.
 * @param allowNull If true, invalid values will be converted to null instead of throwing an error.
 * @returns A transformation function for @Transform()
 */
export function toEnum<T extends object>(enumType: T, allowNull = false) {
  return ({ value }: { value: any }) => {
    if (Object.values(enumType).includes(value as T[keyof T])) {
      return value as T[keyof T];
    }
    if (allowNull) return null;
    throw new Error(
      `Invalid value '${value}', expected one of: ${Object.values(
        enumType
      ).join(", ")}`
    );
  };
}
